import { Link } from '@reach/router';
import ResourceBankTopImage from 'images/subjectSite/Img_ResourceBank_Top.png';
import React from 'react';
import ResourceSearchBox from './ResourceSearchBox';

type Props = {
  subjectCode: string;
  title: string;
  /** Where Back goes */
  backPath: string;
  /** The line under the title, left out when undefined */
  subtitle?: string | null;
  imageSrc: string | null;
  children?: React.ReactNode;
};

/**
 * A resource bank page with the coloured top block (Back, search box, title
 * and picture) over a white content block
 */
const ResourceBankPage = React.forwardRef<HTMLDivElement, Props>(
  ({ subjectCode, title, backPath, subtitle, imageSrc, children }, ref) => (
    <div className="ResourceBank" ref={ref}>
      <div className="Top">
        <div className="Inner">
          <div className="WidthContent">
            <Link to={backPath} className="BtnFour BtnBack" aria-label="Back">
              <span className="Icon_Four" />
              <span className="Txt_Four">Back</span>
            </Link>
            <div className="Table">
              <div className="Desc">
                <div className="ImgHidden">
                  <img src={ResourceBankTopImage} alt="Resource Bank" />
                </div>
                <ResourceSearchBox
                  subjectCode={subjectCode}
                  placeholder="Enter new search..."
                />
                <h1 className="Title">{title}</h1>
                {subtitle !== undefined && (
                  <h2 className="SubDescTxt">{subtitle}</h2>
                )}
              </div>
              <div className="Img">
                {imageSrc && <img src={imageSrc} alt="Resource Bank" />}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="Content">
        <div className="Inner">
          <div className="WidthContent">{children}</div>
        </div>
      </div>
    </div>
  )
);

export default ResourceBankPage;
